import React, { useState, useEffect, useContext } from 'react'
import ClassNames from 'classnames'

// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
import dynamic from 'next/dynamic'
import ControlBar from './ControlBar'
import ControlBarItem from './ControlBar/ControlBarItem'
import List from 'Molecules/List'

import Panel from 'Atoms/Panel'
import Svg from 'Atoms/Svg'
import Modal from 'Components/Modal'
import ErrorBoundary from 'UtilityComponents/ErrorBoundary'
import FeatureFlagWrapper from 'UtilityComponents/FeatureFlagWrapper'

import SearchBarHeader from './SearchBarHeader'
import Cart from './Cart'
import AccountDropdown from './AccountDropdown'
import GarageDropdown from './GarageSection/GarageDropdown'
import { NavbarItem, NavbarItemLink } from './NavbarItem/NavbarItem'
import TopbarLink from './TopbarLink/TopbarLink'
import ListsNavItem from './Lists/ListsNavItem/ListsNavItem'
import JsonLD from './json-ld/JsonLD'
import AppName from 'AppName';

import useKeypress, { KEYCODES } from 'Hooks/useKepress'

import Retry from 'Utilities/Retry'
import useFeatureFlag from '../../Hooks/useFeatureFlag/useFeatureFlag'
import { UserContext } from 'Contexts/UserContext/UserContext'
import { NavigationContext } from 'Contexts/Navigation/NavigationContext'
import { VehicleContext } from 'Contexts/VehicleContext'
import useCart from "Hooks/useCart/useCart";
import { ThemeProvider, speedwayThemes } from 'Contexts/ThemeContext'
import headerStyles from './Header.module.scss'

import YmmModal from './YmmModal'
import ToolboxBlade from './ToolboxBlade/ToolboxBlade'
import HeaderDrawer from './HeaderDrawer'
import SaytDropdown from './SaytDropdown'
import Banners from './Banners'
import GarageSection from './GarageSection'
import BackButton from './PWANavigation/BackButton'
import TextLink from '../../Atoms/TextLink/TextLink'

// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
// const YmmModal = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.YmmModal)))
// const ToolboxBlade = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.ToolboxBlade)))
// const HeaderDrawer = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.HeaderDrawer)))
// const SaytDropdown = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.SaytDropdown)))
// const GarageSection = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.GarageSection)))
// const Banners = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.Banners)))


const Header = ({
    currentTime,
    services,
    children,
    reserveBannerSpace
}) => {
    const [previousMenuItem, setPreviousMenuItem] = useState(null)
    const [searchTerm, setSearchTerm] = useState('')

    const longPlaceholder = "Search by vehicle, category, part number...";
    const shortPlaceholder = "Search...";
    const brandPlaceholder = "Search Speedway Motors"

    const { dispatch: navigationDispatch, state: navigationState } = useContext(
        NavigationContext
    )
    const { ExecuteGarageReload } = useContext(VehicleContext)
    const { context: userState } = useContext(UserContext)
    let headerBreakpointUseToolbox = useFeatureFlag('Header_Breakpoint_Use_Toolbox')

    const { drawer, garage } = navigationState

    const { isDrawerOpen } = drawer
    const { isGarageModalOpen, isYmmModalOpen } = garage

    useEffect(() => {
        //this is so that amp pages can cause the drawer to open and garage dropdown to open on page load
        if (window.location.hash) {
            var hash = window.location.hash.substring(1) //substring removes the # char
            if (hash == 'menu=1') {
                //open MOBILE drawer
                navigationDispatch({
                    type: 'setDrawerState',
                    payload: {
                        drawerState: {
                            isDrawerOpen: true
                        },
                        drawerAction: { type: 'resetNavigation' }
                    }
                })
            } else if (hash == 'vehicle=1') {
                //open MOBILE garage
                handleControlBarMenuClick('garage')
            }
        }
    }, [])

    useKeypress(KEYCODES.escape, () => {
        navigationDispatch({
            type: 'setDrawerState',
            payload: {
                drawer: { isDrawerOpen: false }
            }
        })
    })

    const handleControlBarMenuClick = (
        selectedMenu,
        market = 'street',
        reloadCurrentLocation = false
    ) => {
        if (selectedMenu == previousMenuItem) {
            if (isDrawerOpen || isGarageModalOpen) {
                if (selectedMenu === 'garage') {
                    navigationDispatch({
                        type: 'setGarageState',
                        payload: {
                            garageState: { isGarageModalOpen: false }
                        }
                    })
                } else {
                    navigationDispatch({
                        type: 'setDrawerState',
                        payload: {
                            drawerState: { isDrawerOpen: false }
                        }
                    })
                }

                setPreviousMenuItem(selectedMenu)
                return
            }
        }

        switch (selectedMenu) {
            case 'menu':
                navigationDispatch({
                    type: 'setDrawerState',
                    payload: {
                        drawerState: {
                            isDrawerOpen: true
                        },
                        drawerAction: { type: 'resetNavigation' }
                    }
                })
                break
            case 'shop':
                navigationDispatch({
                    type: 'setDrawerState',
                    payload: {
                        drawerState: {
                            isDrawerOpen: true
                        },
                        drawerAction: { type: 'gotoShopNavigation' }
                    }
                })
                break
            case 'garage':
                navigationDispatch({
                    type: 'setGarageState',
                    payload: {
                        garageState: {
                            isGarageModalOpen: true,
                            market: market
                        }
                    }
                })
                ExecuteGarageReload(reloadCurrentLocation)
                break
            default:
                break
        }
        setPreviousMenuItem(selectedMenu)
    }


    try {
        return (
            <div>
                <header className={headerStyles.pwaSticky}>
                    <Panel
                        className={ClassNames(headerStyles.headerTopBar)}
                        brand={'primary'}
                    >
                        <TopbarLink
                            className={ClassNames(headerStyles.phone)}
                            tone={'contrast'}
                            size={0.875}
                            font={'heading'}
                            href={'tel:18009790122'}
                            testingName={'phoneNumber'}
                        >
                            Talk to the experts. Call 800.979.0122, 7am-10pm,
                            everyday.
                        </TopbarLink>
                        <TopbarLink
                            className={ClassNames(headerStyles.giftCard)}
                            icon={'creditcard'}
                            href={'/giftcards'}
                            testingName={'giftcards'}
                        >
                            GIFT CARDS
                        </TopbarLink>
                        <TopbarLink
                            className={ClassNames(headerStyles.deals)}
                            icon={'deals'}
                            href={'/deals'}
                            testingName={'deals'}
                        >
                            DEALS
                        </TopbarLink>
                        <TopbarLink
                            className={ClassNames(headerStyles.trackOrder)}
                            icon={'trackorder'}
                            href={'/Track/OrderLocator'}
                            testingName={'trackOrder'}
                        >
                            TRACK ORDER
                        </TopbarLink>
                        <TopbarLink
                            className={ClassNames(headerStyles.help)}
                            icon={'help'}
                            href={'/info/helpcenter'}
                            testingName={'helpCenter'}
                        >
                            HELP CENTER
                        </TopbarLink>
                    </Panel>
                    <div className={ClassNames(headerStyles.headerContainer)}>
                        <JsonLD />
                        <Panel
                            className={`${headerStyles.mobileHeaderBlock}`}
                            brand={'primary'}
                        >
                            <BackButton />
                            <TextLink
                                className={headerStyles.mobileIcon}
                                title={'Home Page Link'}
                                href={'/'}
                                data-testid={'header-speedwaylogo-mobile'}
                            >

                                <svg version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <defs>

                                        <symbol id="icon-SpeedwayMotors_Wheel_Full_Color" viewBox="0 0 45 45">
                                            <path fill="#ffc72c" style={{ "fill": "var(--color1, #ffc72c)" }} d="M25.144 0c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.175-16-16-16z"></path>
                                            <path fill="#470a68" style={{ "fill": "var(--color2, #470a68)" }} d="M23.516 19.072h-4.953c-0.212 0-0.331 0.169-0.387 0.303-0.262 0.628-0.506 1.272-0.738 1.919-0.438 1.241-0.028 2.072 1.047 2.072h9.234c1.031 0 1.906-0.65 2.425-1.759 0.616-1.309 1.113-2.694 1.587-4.072 0.375-1.103-0.103-1.897-1.047-1.9h-4.866c-0.594-0.003-0.778-0.384-0.525-1.072 0.436-1.228 0.684-1.864 0.939-2.495l-0.205 0.574c0.453-1.156 1.281-1.656 2.222-1.319 0.272 0.094 0.372 0.381 0.309 0.731-0.034 0.197-0.109 0.394-0.175 0.588-0.141 0.394-0.291 0.838-0.444 1.259l4.988-0.006c0.109 0 0.294-0.162 0.347-0.294 0.192-0.425 0.441-1.060 0.668-1.704l0.066-0.215c0.431-1.262 0.059-2.019-1.016-2.022-1.3-0.003-13.894 0.003-13.894 0.003l2.341 1.266c-0.105 0.142-0.553 1.253-0.988 2.37l-0.34 0.992c-0.184 0.488-0.378 0.988-0.481 1.494-0.175 0.847 0.209 1.441 0.894 1.509 0.163 0.016 0.331 0.019 0.497 0.019l4.475 0.006c0.75 0 0.931 0.359 0.613 1.219-0.206 0.559-0.419 1.116-0.637 1.675-0.462 1.188-1.019 1.584-2.038 1.462-0.541-0.066-0.7-0.416-0.469-1.063 0.172-0.491 0.359-1.025 0.55-1.541zM32.106 21.828c-0.125-0.075-0.281-0.113-0.459-0.113-0.181 0-0.334 0.041-0.462 0.116s-0.225 0.188-0.288 0.322c-0.025 0.056-0.047 0.116-0.059 0.178-0.011 0.057-0.017 0.122-0.017 0.188 0 0.146 0.029 0.285 0.082 0.412l-0.003-0.007c0.056 0.137 0.156 0.247 0.281 0.322s0.284 0.116 0.466 0.116c0.181 0 0.334-0.038 0.459-0.116 0.176-0.11 0.302-0.286 0.343-0.492l0.001-0.005c0.011-0.063 0.017-0.136 0.017-0.211s-0.006-0.148-0.018-0.219l0.001 0.008c-0.009-0.063-0.031-0.119-0.056-0.175-0.063-0.141-0.156-0.247-0.288-0.322zM32.309 22.719c-0.009 0.053-0.025 0.103-0.047 0.15-0.050 0.113-0.132 0.205-0.235 0.264l-0.003 0.001c-0.1 0.063-0.231 0.094-0.381 0.094-0.153 0-0.281-0.031-0.387-0.094s-0.181-0.147-0.234-0.266c-0.022-0.047-0.038-0.097-0.047-0.147-0.009-0.053-0.012-0.113-0.012-0.181 0-0.072 0.003-0.134 0.012-0.188 0.009-0.050 0.025-0.1 0.047-0.147 0.050-0.116 0.128-0.206 0.234-0.266 0.103-0.059 0.231-0.087 0.387-0.087 0.15 0 0.281 0.031 0.384 0.087 0.106 0.063 0.184 0.15 0.234 0.266 0.040 0.090 0.063 0.196 0.063 0.307 0 0.010-0 0.019-0.001 0.029l0-0.001c0 0.066 0 0.125-0.016 0.178z"></path>
                                            <path fill="#470a68" style={{ "fill": "var(--color2, #470a68)" }} d="M32.031 22.484c0.024-0.040 0.038-0.089 0.038-0.141 0-0.005-0-0.011-0-0.016l0 0.001c0-0.094-0.031-0.169-0.094-0.216-0.059-0.047-0.156-0.069-0.288-0.069h-0.434v1h0.178v-0.394h0.225c0.075 0 0.131 0.012 0.163 0.041s0.050 0.078 0.050 0.141v0.212h0.178v-0.231c0-0.063-0.013-0.113-0.034-0.153s-0.059-0.066-0.109-0.084c0.052-0.016 0.095-0.048 0.124-0.090l0.001-0.001zM31.828 22.462c-0.041 0.028-0.1 0.041-0.178 0.041h-0.216v-0.313h0.219c0.084 0 0.141 0.012 0.178 0.038s0.053 0.063 0.053 0.116c0 0.053-0.019 0.094-0.056 0.119z"></path>
                                            <path fill="#470a68" style={{ "fill": "var(--color2, #470a68)" }} d="M30.769 2.938l-0.038-0.013-0.25-0.103-0.063-0.031-0.231-0.087-0.087-0.031-0.219-0.081c-0.062-0.026-0.166-0.062-0.271-0.095l-0.041-0.011-0.119-0.038-0.2-0.063-0.125-0.038-0.197-0.056-0.137-0.034-0.191-0.050-0.334-0.078-0.15-0.031-0.184-0.041-0.156-0.031-0.181-0.031-0.169-0.028-0.175-0.028-0.172-0.025-0.172-0.022-0.181-0.019-0.166-0.019-0.191-0.016-0.159-0.016-0.203-0.009-0.15-0.012-0.231-0.006-0.125-0.006h-0.359c-0.006 0-0.013 0-0.020 0-4.762 0-8.975 2.349-11.545 5.951l-0.029 0.043c-0.358 0.501-0.712 1.076-1.026 1.674l-0.039 0.082c-0.983 1.877-1.56 4.1-1.56 6.457 0 0.394 0.016 0.785 0.048 1.171l-0.003-0.051h2.15c-0.006-0.175-0.012-0.35-0.012-0.528l0.006-0.294-0.006-0.281c0.011-6.651 5.402-12.038 12.053-12.044h0.026c0.391 0 0.775 0.022 1.156 0.059l0.063 0.006 0.156 0.019 0.188 0.022 0.031 0.003c2.83 0.395 5.295 1.723 7.126 3.657l0.005 0.006 0.462-1.169c2.459 2.394 3.984 5.736 3.984 9.435 0 0.003 0 0.006 0 0.010v-0c0 6.887-5.306 12.563-12.050 13.144h-0.009c-0.337 0.034-0.729 0.053-1.125 0.053h-0c-5.856-0.006-10.734-4.375-11.828-10.159h-2.084c1.458 6.431 7.12 11.162 13.89 11.172h0.001l0.356-0.003c0.106 0 0.206-0.006 0.313-0.012h0.038c7.541-0.398 13.506-6.606 13.512-14.209v-0.001c-0.005-5.82-3.5-10.822-8.506-13.027l-0.091-0.036z"></path>
                                        </symbol>

                                    </defs>
                                    <use href="#icon-SpeedwayMotors_Wheel_Full_Color" />
                                </svg>
                            </TextLink>

                            <SearchBarHeader
                                searchTerm={searchTerm}
                                setSearchTerm={setSearchTerm}
                                placeholder={brandPlaceholder}
                                className={headerStyles.mobileSearchBar}

                                dataTesting={'searchBarMobile'}
                                isMobile={true}
                            />


                        </Panel>
                        <Panel className={ClassNames(headerStyles.headerDesktopView)} layer={0}>
                            <List
                                className={headerStyles.ds9Header}
                                itemLayout={'horizontal'}
                                component={'div'}
                                display={'grid'}
                            >
                                <div
                                    className={ClassNames(
                                        headerStyles.navLeft,
                                        headerStyles.menuItem1
                                    )}
                                >
                                    <NavbarItem
                                        component={'div'}
                                        className={ClassNames(
                                            headerStyles.headerItem,
                                            headerStyles.mobileHide,
                                            headerStyles.mobileLimitedHide,
                                        )}
                                        pwaOnly
                                        hover

                                    ><BackButton /> </NavbarItem>
                                    <NavbarItem
                                        className={ClassNames(
                                            headerStyles.headerItem,
                                            headerStyles.mobileHide,
                                            headerStyles.mobileLimitedHide,
                                            headerStyles.headerMenu
                                        )}
                                        icon={'menu'}
                                        onClick={() =>
                                            handleControlBarMenuClick('menu')
                                        }
                                        hover
                                        data-testid={'menu'}
                                        aria-label={'menu'}
                                    />
                                    <NavbarItemLink
                                        className={ClassNames(
                                            headerStyles.headerItem,
                                            headerStyles.logoHeaderItem,
                                            headerStyles.headerLogo
                                        )}
                                        title={'Home Page Link'}
                                        data-testid={'header-speedwaylogo'}
                                        href={'/'}
                                    >
                                        <Svg
                                            icon={'SpeedwayMotors_Logo_Full_Color'}
                                            size={11}
                                            className={ClassNames(
                                                headerStyles.logoDesktop,
                                                headerStyles.mobileHide,
                                                headerStyles.tabletHide,
                                                headerStyles.mobileLimitedHide
                                            )}
                                        />
                                        <Svg
                                            icon={'SpeedwayMotors_Wheel_Full_Color'}
                                            size={7}
                                            className={ClassNames(
                                                headerStyles.logoTablet,
                                                headerStyles.mobileHide,
                                                headerStyles.desktopHide,
                                                headerStyles.mobileLimitedHide
                                            )}
                                            brand={'primary'}
                                        />
                                        <Svg
                                            icon={'SpeedwayMotors_Wheel_Full_Color'}
                                            size={4}
                                            className={ClassNames(
                                                headerStyles.tabletHide,
                                                headerStyles.desktopHide
                                            )}
                                            brand={'primary'}
                                        />
                                    </NavbarItemLink>
                                    <NavbarItem
                                        className={ClassNames(
                                            headerStyles.headerItem,
                                            headerStyles.mobileHide,
                                            headerBreakpointUseToolbox ? headerStyles.tabletHide : undefined,
                                            headerStyles.mobileLimitedHide,
                                            headerStyles.headerShopParts
                                        )}
                                        icon={'parts'}
                                        primaryText={'Shop'}
                                        secondaryText={'Parts'}
                                        data-testid={'shopParts'}
                                        onClick={() =>
                                            handleControlBarMenuClick('shop')
                                        }
                                        hover
                                    />
                                    <ErrorBoundary key={`toolbox-blade`}
                                        showFallbackUI
                                        fallbackUI={<NavbarItem
                                            className={ClassNames(
                                                headerStyles.headerItem,
                                                headerStyles.mobileHide,
                                                headerBreakpointUseToolbox ? undefined : headerStyles.tabletHide,
                                                headerStyles.mobileLimitedHide,
                                                headerStyles.headerToolbox
                                            )}
                                            primaryText={'Learn'}
                                            secondaryText={'Toolbox'}
                                            icon={'toolbox'}
                                            onClick={() => window.location.href = '/the-toolbox'
                                            }
                                            hover
                                            data-testid={'toolbox-fallback'}
                                            aria-label={'toolbox'}
                                        />}>
                                        <ToolboxBlade
                                            className={ClassNames(
                                                headerStyles.headerItem,
                                                headerStyles.mobileHide,
                                                headerBreakpointUseToolbox ? undefined : headerStyles.tabletHide,
                                                headerStyles.mobileLimitedHide,
                                                headerStyles.headerToolbox
                                            )}
                                            contentServiceUrl={services?.content?.url}

                                        />
                                    </ErrorBoundary>
                                </div>
                                <div
                                    className={ClassNames(
                                        headerStyles.navCenter,
                                        headerStyles.menuItem2
                                    )}
                                >
                                    <SearchBarHeader
                                        searchTerm={searchTerm}
                                        setSearchTerm={setSearchTerm}
                                        placeholder={longPlaceholder}
                                        className={ClassNames(headerStyles.searchBar)}
                                        dataTesting={'searchBarDesktop'}
                                        isMobile={false}
                                    />
                                </div>
                                <div
                                    className={ClassNames(
                                        headerStyles.navRight,
                                        headerStyles.menuItem3
                                    )}
                                >
                                    <GarageSection services={services} />
                                    <AccountDropdown />
                                    <ListsNavItem />
                                    <Cart
                                        classNames={ClassNames(
                                            headerStyles.headerItem,
                                            headerStyles.mobileHide,
                                            headerStyles.mobileLimitedHide,
                                            headerStyles.headerShoppingCart
                                        )}
                                        url={services?.checkout?.url}
                                    />
                                </div>
                            </List>
                        </Panel>
                        <Banners url={services?.content?.url} reserveBannerSpace={reserveBannerSpace} />
                        <HeaderDrawer
                            currentTime={currentTime}

                            isDrawerOpen={isDrawerOpen}
                            closeFunction={() => {
                                navigationDispatch({
                                    type: 'setDrawerState',
                                    payload: {
                                        drawer: {
                                            isDrawerOpen: false
                                        }
                                    }
                                })
                            }}
                            services={services}
                        />
                        {isYmmModalOpen && (
                            <ErrorBoundary>
                                <YmmModal
                                    services={services}
                                    webUserGuid={userState?.userGuid}
                                />
                            </ErrorBoundary>
                        )}
                        <Modal
                            toggleOpen={(value) =>
                                navigationDispatch({
                                    type: 'setGarageState',
                                    payload: {
                                        garageState: {
                                            isGarageModalOpen: value
                                        }
                                    }
                                })
                            }
                            alignItems={'flex-start'}
                            className={headerStyles.garageModal}
                            open={isGarageModalOpen}
                            contentAboveModal={
                                <div className={headerStyles.closeButtonWrapper}>
                                    <Panel className={headerStyles.modalClose} onClick={() =>
                                        navigationDispatch({
                                            type: 'setGarageState',
                                            payload: {
                                                garageState: {
                                                    isGarageModalOpen: false
                                                }
                                            }
                                        })
                                    }>
                                        <Svg size={0.75} icon={'close'} data-testid={"modalCloseButton"} />
                                    </Panel>
                                </div>
                            }
                            allowOutsideClickClose
                        >
                            <Panel className={headerStyles.garagePanel}>
                                <GarageDropdown
                                    userGuid={userState?.userGuid}
                                    services={services}
                                />
                            </Panel>
                        </Modal>
                        <SaytDropdown
                            className={
                                (headerStyles.headerItem, headerStyles.menuItem5)
                            }
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            mobilePlaceholder={brandPlaceholder}
                            desktopPlaceholder={longPlaceholder}
                            services={services}

                        />
                        <FeatureFlagWrapper
                            ff={"Dark_Control_Bar_Enabled"}
                            childrenIfFalse={
                                <MobileLowerNav
                                    key={false}
                                    onControlBarMenuClick={handleControlBarMenuClick}
                                    userGuid={userState?.userGuid}
                                    services={services}
                                    darkControlBarEnabled={false}
                                />}
                        >

                            <MobileLowerNav
                                key={true}
                                onControlBarMenuClick={handleControlBarMenuClick}
                                userGuid={userState?.userGuid}
                                services={services}
                                darkControlBarEnabled={true}
                            />
                        </FeatureFlagWrapper>


                    </div>
                </header>
                {children}
            </div>

        )
    } catch (e) {
        console.error(e)
        return false
    }
}
const MobileLowerNav = ({ onControlBarMenuClick, darkControlBarEnabled }) => {
    const { state: navigationState, dispatch: navigationDispatch } = useContext(
        NavigationContext
    )
    const { context: vehicleState, ExecuteGarageReload } = useContext(
        VehicleContext
    )

    const { cart } = useCart();
    const { discovery, controlBar, drawer, email } = navigationState
    const totalCustomerVehicles = vehicleState?.customerVehicles
        ? vehicleState.customerVehicles.length
        : 0
    const {
        isMenuActive,
        isShopActive,
        isGarageActive,
        isAccountActive,
        isCartActive
    } = controlBar

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.SMI) {
                window.SMI.showDs9YMMDropdownMobile = function (
                    market = 'street',
                    reloadCurrentLocation = false
                ) {
                    const totalCustomerVehicles = vehicleState?.customerVehicles
                        ? vehicleState.customerVehicles.length
                        : 0

                    if (totalCustomerVehicles > 0) {
                        onControlBarMenuClick(
                            'garage',
                            market,
                            reloadCurrentLocation
                        )
                    } else {
                        navigationDispatch({
                            type: 'setGarageState',
                            payload: {
                                garageState: {
                                    isYmmModalOpen: true,
                                    market: market
                                }
                            }
                        })
                        ExecuteGarageReload(reloadCurrentLocation)

                        return
                    }
                }
            }

            const isAnyControlBarItemActive =
                !isMenuActive && !isShopActive && !isGarageActive
            if (
                !isAccountActive &&
                isAnyControlBarItemActive &&
                window.location.href.toLowerCase().includes('/account')
            ) {
                navigationDispatch({
                    type: 'setControlBarState',
                    payload: {
                        controlBarState: {
                            isAccountActive: true
                        }
                    }
                })
            }
            if (
                !isCartActive &&
                isAnyControlBarItemActive &&
                window.location.href.toLowerCase().includes('/shoppingcart')
            ) {
                navigationDispatch({
                    type: 'setControlBarState',
                    payload: {
                        controlBarState: {
                            isCartActive: true
                        }
                    }
                })
            }
        }
    }, [typeof window, onControlBarMenuClick, vehicleState?.customerVehicles])

    const items = [
        {
            id: 'menu',
            icon: 'menu',
            onClick: () => onControlBarMenuClick('menu'),
            label: 'Menu',
            isActiveKey: 'isMenuActive'
        },
        {
            id: 'shop',
            icon: 'parts',
            onClick: () => onControlBarMenuClick('shop'),
            label: 'Shop',
            isActiveKey: 'isShopActive'
        },
        {
            id: 'garage',
            icon: 'garage',
            onClick: () => {
                onControlBarMenuClick('garage')
            },
            label: 'Garage',
            isActiveKey: 'isGarageActive'
        },
        {
            id: 'cart',
            icon: 'cart',
            href: '/shoppingcart',
            label: 'Cart',
            isActiveKey: 'isCartActive'
        }
    ]

    if (false) {//controlBarSearchEnabled){ //running an AA experiment having control bar search off for both treatments
        items.push({
            id: 'search',
            icon: 'magnifyingglass',
            label: 'Search',
            onClick: () => navigationDispatch({
                type: 'setDiscoveryState',
                payload: { discoveryState: { isSaytModalOpen: true } }
            })
        })
    }
    else {
        items.push({
            id: 'account',
            icon: 'user',
            href: '/account',
            label: 'Account',
            isActiveKey: 'isAccountActive'
        })
    }
    return (
        <ThemeProvider
            value={
                darkControlBarEnabled
                    ? speedwayThemes.Dark
                    : speedwayThemes.Light
            }
        >
            <ControlBar
                hide={discovery.isSaytModalOpen}
                darkControlBarEnabled={darkControlBarEnabled}
            >
                {items.map((item) => {
                    const isActive = controlBar[item.isActiveKey]

                    let props = null

                    if (item.id === 'cart') {
                        props = {
                            badge: true,
                            badgeProps: {
                                brand: 'secondary',
                                number: cart?.itemCount ?? 0,
                                size: 'small'
                            }
                        }
                    } else if (item.id === 'garage') {
                        let garageBadgeBrand = darkControlBarEnabled
                            ? 'secondarypalette_purple'
                            : null
                        let garageBadgeIntent = darkControlBarEnabled
                            ? null
                            : 'action'
                        props = {
                            badge: true,
                            badgeProps: {
                                brand: garageBadgeBrand,
                                intent: garageBadgeIntent,
                                number: totalCustomerVehicles,
                                size: 'small',
                                removeNumber: true
                            }
                        }
                    }

                    return (
                        <ControlBarItem
                            id={item.id}
                            key={item.label}
                            href={item.href}
                            onClick={item.onClick}
                            label={item.label}
                            icon={item.icon}
                            isActive={isActive}
                            invert={darkControlBarEnabled}
                            {...props}
                        />
                    )
                })}
            </ControlBar>
        </ThemeProvider>
    )
}

export default Header
